import { render, staticRenderFns } from "./EmHeader.vue?vue&type=template&id=08750e04&scoped=true&"
import script from "./EmHeader.vue?vue&type=script&lang=js&"
export * from "./EmHeader.vue?vue&type=script&lang=js&"
import style0 from "./EmHeader.vue?vue&type=style&index=0&id=08750e04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08750e04",
  null
  
)

export default component.exports